import React from 'react'

import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useAuth } from './Auth'

// import { ReactComponent as Youtube } from '../assets/yt.svg'


function NewFooter() {
    const auth = useAuth()
    const location = useLocation()
    const navigate = useNavigate()
    const {t} = useTranslation()

    return (
        <StyledFooter className="footer mt-auto py-3">
            {/*<div className="container">*/}

            <div className="d-flex footer-inner-wrapper">
                <p className={'text-center'}>{t('footer_developed')}</p>
                <p className={'text-center'}>
                    <a href="https://www.linkedin.com/company/amani-sk/" target="_blank" rel="noreferrer"><i
                        className="bi bi-linkedin secondary-pink-text-color"></i></a>&nbsp;&nbsp;
                    <a href="https://www.facebook.com/amani.tvoja.online.kancelaria" target="_blank" rel="noreferrer"><i
                        className="bi bi-facebook secondary-pink-text-color"></i></a>&nbsp;&nbsp;
                    <a href="https://www.instagram.com/amani_tvoja_online_kancelaria" target="_blank"
                       rel="noreferrer"><i className="bi bi-instagram secondary-pink-text-color"></i></a>
                </p>
                <p className={'text-center'}><span className={'font-shantell secondary-pink-text-color'}>{t('footer_need_help')}</span><br/>
                    {t('footer_write_message')} <a href="mailto:pomozemti@amani.sk">{t('footer_click_here')}</a>.
                </p>

                <p className="copyr">
                    Copyright 2024 © Katarína Huňady
                </p>
                <div className="d-flex align-items-center">
                    <ul className="nav justify-content-center">
                        <li className="nav-item">
                            <Link to={'/gdpr'}
                                  className={'nav-link px-2 ' + (location.pathname.startsWith('/gdpr') ? 'active' : '')}>{t('footer_personal_data')}</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={'/privacy-policy'}
                                  className={'nav-link px-2 ' + (location.pathname.startsWith('/privacy-policy') ? 'active' : '')}>{t('footer_privacy_policy')}</Link>
                        </li>
                        <li className="nav-item">
                            <Link to={'/licencie'}
                                  className={'nav-link px-2 ' + (location.pathname.startsWith('/licencie') ? 'active' : '')}>{t('footer_license')}</Link>
                        </li>
                        {/*<li className="nav-item">*/}
                        {/*    <Link to={'/faq'}*/}
                        {/*          className={'nav-link px-2 ' + (location.pathname.startsWith('/faq') ? 'active' : '')}>FAQ</Link>*/}
                        {/*</li>*/}
                        <li className="nav-item">
                            <Link to={'/contact'}
                                  className={'nav-link px-2 ' + (location.pathname.startsWith('/contact') ? 'active' : '')}>{t('footer_contact')}</Link>
                        </li>
                        {auth.isAuthenticated &&
                            <li className="nav-item">
                                <Link to={'/about-us'}
                                      className={'nav-link px-2 ' + (location.pathname.startsWith('/about-us') ? 'active' : '')}>{t('footer_about')}</Link>
                            </li>}
                    </ul>
                </div>
            </div>

            {/*<div className="d-flex footer-inner-wrapper">*/}
            {/*    <img src={logo} className="f-logo"/>*/}
            {/*    /!*<p>*!/*/}
            {/*    /!*    Strucny text*!/*/}
            {/*    /!*</p>*!/*/}
            {/*    <ul className="nav col-md-5 justify-content-center list-unstyled d-flex">*/}
            {/*        <li className="ms-3"><a className="text-muted" target="_blank"*/}
            {/*                                href="https://www.facebook.com/Amani-01907945234564"*/}
            {/*                                rel="noreferrer"><Fb/></a></li>*/}
            {/*        /!*<li className="ms-3"><a className="text-muted" target="_blank"*!/*/}
            {/*        /!*                        href="https://www.youtube.com/channel/UCe72jOsxRSZcYHWYVds1_4w"><Youtube/></a>*!/*/}
            {/*        /!*</li>*!/*/}
            {/*        <li className="ms-3"><a className="text-muted" target="_blank"*/}
            {/*                                href="https://www.instagram.com/amani.sk/"*/}
            {/*                                rel="noreferrer"><Insta/></a>*/}
            {/*        </li>*/}
            {/*        <li className="ms-3"><a className="text-muted" target="_blank"*/}
            {/*                                href="https://www.linkedin.com/in/xxx-522803239/"*/}
            {/*                                rel="noreferrer"><Linkedin/></a>*/}
            {/*        </li>*/}
            {/*    </ul>*/}
            {/*    <p>*/}
            {/*        Potrebujete pomoc? Napíšte nám správu <a href="mailto:info@amani.sk">kliknutím sem</a>. <br/>*/}
            {/*        Kontakt pre médiá: info@amani.sk*/}
            {/*    </p>*/}
            {/*    <p className="copyr">*/}
            {/*        Copyright (c) 2024*/}
            {/*    </p>*/}
            {/*    <div className="d-flex align-items-center">*/}
            {/*        <ul className="nav justify-content-center">*/}
            {/*            <li className="nav-item">*/}
            {/*                <Link to={'/gdpr'}*/}
            {/*                      className={'nav-link px-2 ' + (location.pathname.startsWith('/gdpr') ? 'active' : '')}>Podmienky*/}
            {/*                    a GDPR</Link>*/}
            {/*            </li>*/}
            {/*            <li className="nav-item">*/}
            {/*                <Link to={'/faq'}*/}
            {/*                      className={'nav-link px-2 ' + (location.pathname.startsWith('/faq') ? 'active' : '')}>FAQ</Link>*/}
            {/*            </li>*/}
            {/*            <li className="nav-item">*/}
            {/*                <Link to={'/contact'}*/}
            {/*                      className={'nav-link px-2 ' + (location.pathname.startsWith('/contact') ? 'active' : '')}>Kontakt</Link>*/}
            {/*            </li>*/}
            {/*            {auth.isAuthenticated &&*/}
            {/*                <li className="nav-item">*/}
            {/*                    <Link to={'/about-us'}*/}
            {/*                          className={'nav-link px-2 ' + (location.pathname.startsWith('/about-us') ? 'active' : '')}>O*/}
            {/*                        nás</Link>*/}
            {/*                </li>}*/}
            {/*        </ul>*/}
            {/*    </div>*/}


            {/*</div>*/}
            {/*</div>*/}

            <div className="gradient-border"/>
        </StyledFooter>
    )
}


const StyledFooter = styled.footer`
    background: #393E5E;
    min-height: 250px;
    position: relative;

    .gradient-border {
        height: 6px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background: #393E5E;
    }

    .container {
        height: 100%;
    }

    .footer-inner-wrapper {
        //height: 100%;
        min-height: 250px;
        flex-direction: column;
        justify-content: space-around;

        > * {
            align-self: center;
            margin: 0;
        }

        p.copyr {
            font-size: 15px;
        }

        p {
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 140%;
            text-align: center;
            color: rgba(255, 255, 255, 0.7);

            a {
                color: rgba(255, 255, 255, 0.7);
            }
        }

        img.f-logo {
            width: 186px;
            //height: 42px;
        }

        ul.nav {
            svg {
                width: 35px;
                height: 35px;
                fill: #a8a8a8;

                &:hover {
                    fill: #939393;
                }
            }

            li.nav-item {
                position: relative;

                span.nav-link {
                    font-size: 13px;
                    color: #000;
                }

                a {
                    // font-size: 13px;
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.7);
                    text-decoration: underline;

                    &.active {
                        // color: #EF5D6C;
                    }

                    &:hover {
                        text-decoration: underline;
                    }
                }

                &::after {
                    color: rgba(255, 255, 255, 0.7);
                    content: "|";
                    position: absolute;
                    right: -2px;
                    top: 7px;
                }

                &:last-child {
                    &::after {
                        content: "";
                    }
                }
            }
        }
    }


    @media only screen and (max-width: 920px) {
        .footer-inner-wrapper {
            p {
                font-size: 16px;
                padding: 20px 0;
            }

            ul.nav li.nav-item {
                a {
                    font-size: 16px;
                }

                &::after {
                    color: rgba(255, 255, 255, 0.7);
                    content: "|";
                    position: absolute;
                    right: -2px;
                    top: 8px;
                }
            }
        }
    }


    @media only screen and (max-width: 767px) {
        .container {
            > div {
                justify-content: center !important;
            }
        }
    }
`

export default NewFooter
